'use strict';

import { body } from '@jspartials/general-utils';
import { classes, addClassToElement } from '@jspartials/class-list-utils';
import initBannersList from '../components/banners-list';
import initBannerCarousel from '../components/carousel';
import Recommendations from '@jsclasses/recommendations';

// Selectors
const selector = {
  header: {
    submenu: '.js-home-header-submenu'
  },
  list: {
    products: {
      wrapper: '.js-list__wrapper-recommendations'
    }
  }
};

// Elements
const element = {
  header: {
    submenu: document.querySelector(selector.header.submenu) || null
  },
  list: {
    products: {
      wrapper: document.querySelectorAll(selector.list.products.wrapper) || []
    }
  }
};

const initProductLists = () => {
  element.list.products.wrapper.forEach((wrapper) => {
    const maxVisibleItems = wrapper.dataset.numberOfVisibleProducts || 4;

    new Recommendations({
      wrapper: wrapper,
      showPrice: true,
      maxVisibleItems: maxVisibleItems,
      staticContent: true
    });
  });
};

document.addEventListener('DOMContentLoaded', function () {
  initBannersList();
  initBannerCarousel();
  initProductLists();

  if (element.header.submenu) {
    addClassToElement(body, classes.has.headerSubmenu);
  }
});
